import React from "react";
import "./ProfileGallery.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { Link } from "react-router-dom";

const LeftArrow = ({ onClick }) => (
  <div className="LeftArrow" onClick={onClick} />
);

const RightArrow = ({ onClick }) => (
  <div className="RightArrow" onClick={onClick} />
);

const ProjectInfo = ({ basicInformation, tags }) => (
  <div className="ProjectInfo">
    <h4>{basicInformation.title}</h4>
    <p>
      Posted in <strong>{basicInformation.category.label}</strong>
    </p>
    <div className="Tags">
      {tags.skills &&
        tags.skills.map((tag, i) => (
          <div key={i} className="Tag">
            {tag.label}
          </div>
        ))}
    </div>
  </div>
);

const ProjectImage = ({ images, basicInformation, tags, handleImageLoad }) => (
  <>
    {images[0] && (
      <div className="ProjectImage">
        <div
          className="image"
          style={{
            backgroundImage: `url(${images[0].image})`
          }}
        />
        <img
          style={{ display: "none" }}
          onLoad={handleImageLoad}
          src={images[0].image}
          alt=""
        />
        <ProjectInfo basicInformation={basicInformation} tags={tags} />
      </div>
    )}
  </>
);

class ProfileGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
  }
  handleImageLoad = () => {
    this.setState({ loaded: true });
  };

  componentDidUpdate(prevProps) {
    if (this.props.loaded !== prevProps.loaded) {
      this.setState({ loaded: false });
      setTimeout(() => this.setState({ loaded: true }), 1000);
    }
  }

  render() {
    const { projects } = this.props;

    const settings = {
      dots: true,
      infinite: false,
      speed: 600,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />
    };

    return (
      <div
        className="ProfileGallery"
        data-visible={this.props.loaded}
        data-loaded={this.state.loaded}
      >
        <Slider {...settings}>
          {projects &&
            projects.map((project, i) => {
              return (
                <Link to={`/project/${project.id}`} key={i}>
                  <ProjectImage
                    handleImageLoad={this.handleImageLoad}
                    {...project}
                  />
                </Link>
              );
            })}
        </Slider>
      </div>
    );
  }
}

export default ProfileGallery;
